/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MegaphoneIcon16Light } from './MegaphoneIcon16Light';
import { MegaphoneIcon16Regular } from './MegaphoneIcon16Regular';
import { MegaphoneIcon16Solid } from './MegaphoneIcon16Solid';
import { MegaphoneIcon20Light } from './MegaphoneIcon20Light';
import { MegaphoneIcon20Regular } from './MegaphoneIcon20Regular';
import { MegaphoneIcon20Solid } from './MegaphoneIcon20Solid';
import { MegaphoneIcon24Regular } from './MegaphoneIcon24Regular';
import { MegaphoneIcon24Solid } from './MegaphoneIcon24Solid';
import { MegaphoneIcon32Regular } from './MegaphoneIcon32Regular';
import { MegaphoneIcon64Regular } from './MegaphoneIcon64Regular';
var sizes = {
    16: {
        light: MegaphoneIcon16Light,
        regular: MegaphoneIcon16Regular,
        solid: MegaphoneIcon16Solid,
    },
    20: {
        light: MegaphoneIcon20Light,
        regular: MegaphoneIcon20Regular,
        solid: MegaphoneIcon20Solid,
    },
    24: {
        regular: MegaphoneIcon24Regular,
        solid: MegaphoneIcon24Solid,
    },
    32: {
        regular: MegaphoneIcon32Regular,
    },
    64: {
        regular: MegaphoneIcon64Regular,
    },
};
export var MegaphoneIcon = forwardRef('MegaphoneIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
